import React, { Component } from 'react'
import { Row, Col, Modal, Icon } from 'antd';
import MainLayout from "../../components/layouts/mainLayout";
import ActionButton from '../../components/common/buttons/actionButton'
import {
    useQuery
} from "@apollo/client";
import { FORM_DOCUMENTS } from '../../utils/query';
import Info from '../../components/common/info';

class FormItem extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            modalVisible: false,
            modalTitle: '',
            modalImage: ''
        }

        this.showModal = this.showModal.bind(this);
        this.hideModal = this.hideModal.bind(this);
    }

    showModal(title, image) {
        this.setState({
            modalTitle: title,
            modalImage: image,
            modalVisible: true
        })
    }

    hideModal() {
        this.setState({
            modalVisible: false
        })
    }


    render() {
        return (

            <Col xs={24} sm={12} md={8} lg={8} xl={8} className={"formsItem"}>
                <Modal
                    visible={this.state.modalVisible}
                    title={this.state.modalTitle}
                    onOk={this.hideModal}
                    onCancel={this.hideModal}
                    footer={[
                        <div className="modalCdnteredFooter">
                            <ActionButton clickFunc={(e) => { this.hideModal() }} theme={"dark"} icon={"close"} text={"بستن"} />
                        </div>
                    ]}
                >
                    <div className="certificatesModalImageWrapper">
                        <img src={this.state.modalImage} alt="" />
                    </div>
                </Modal>
                <div className="formsItemInner">
                    <div className="formsItemTitle">
                        <div>
                            <Icon type="caret-left" />
                        </div>
                        <p>{this.props.title}</p>
                    </div>
                    <div className="formsItemDesc">
                        <p className={"formsItemDescText"}>
                            {this.props.description}
                        </p>
                    </div>
                    <div className="formsButtons">
                        <div className="formsButton">
                            <div className="normalCircBtn darkBtn">
                                <a href={this.props.imageSrc} target={'__blank'}>
                                    <Icon type="download" />
                                </a>
                            </div>
                        </div>

                        <div className="formsButton">
                            <div className="normalCircBtn darkBtn">
                                <a onClick={(e) => { this.showModal(this.props.title, this.props.imageSrc) }}>
                                    <Icon type="eye" />
                                </a>
                            </div>
                        </div>
                    </div>
                </div>
            </Col>

        )
    }
}

export default function Forms() {
    const { loading, error, data } = useQuery(FORM_DOCUMENTS);

    if (loading) return <p>Loading...</p>;
    if (error) return <p>Error :(</p>;

    return (
        <MainLayout>
            <div className={"formsWrapper"}>
                <div className="container">
                    {
                        loading ? <p>Loading...</p> : <></>
                    }
                    {
                        error ? <p>error :(</p> : <></>
                    }
                    <div className="formsMainWrapper">
                        <Row className={"formsRow"}>
                            {
                                data.formDocuments.data.attributes.documents.map((item, index) => {
                                    return (
                                        <FormItem key={item.id} title={item.title} description={item.description} imageSrc={ Info.UPLOADS_URL + item.document.data.attributes.url} />
                                    )
                                })
                            }
                        </Row>
                    </div>
                </div>
            </div>
        </MainLayout>
    )
}
